import styled from "styled-components";
import { Box, Button, Typography } from "@mui/material";
import { shouldForwardProp as muiShouldForwardProp } from "@mui/system";
import PopUpPhpto from "@assets/svg/popUpPhpto.svg?react";


interface ResponsiveProps {
  $isPhone?: boolean;
  $lang?: string;
}

const shouldForwardProp = (prop: PropertyKey) =>
  muiShouldForwardProp(prop) && prop !== "$isPhone" && prop !== "$lang";

export const ModalWrapper = styled(Box).withConfig({ shouldForwardProp })<ResponsiveProps>`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: ${({ $isPhone }) => ($isPhone ? "90vw" : "673px")};
  outline: none;
  border-radius: 24px;
  overflow: hidden;
`;

export const StyledImage = styled(PopUpPhpto)<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "150px" : "220px")};
  height: ${({ $isPhone }) => ($isPhone ? "200px" : "280px")};
  margin-block: ${({ $isPhone }) => ($isPhone ? "24px" : "42px")};
`;

export const InlineSpacer = styled.span`
  margin-inline: 5px;
`;


export const ImageContainer = styled(Box)`
  background-color: #f7f4ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  position: relative;
`;

export const CloseIconWrapper = styled(Box).withConfig({ shouldForwardProp })<ResponsiveProps>`
  position: absolute;
  top: 10px;
  right: ${({ $lang }) => ($lang === "ar" ? "10px" : "unset")};
  left: ${({ $lang }) => ($lang === "en" ? "10px" : "unset")};
  z-index: 999;
  cursor: pointer;
  font-size: 14px;

  span {
    background: white;
    border-radius: 50%;
    padding: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }
`;

export const ContentBox = styled(Box).withConfig({ shouldForwardProp })<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isPhone }) => ($isPhone ? "center" : "start")};
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
  gap: 10px;
  background: white;
  border-bottom: 1px solid #e9e9e7;
  text-align: ${({ $isPhone }) => ($isPhone ? "center" : "start")};
`;

export const Title = styled(Typography).withConfig({ shouldForwardProp })<ResponsiveProps>`
  font-weight: 700;
  font-size: ${({ $isPhone }) => ($isPhone ? "18px" : "24px")};
  color: #331860;
`;

export const Description = styled(Typography).withConfig({ shouldForwardProp })<ResponsiveProps>`
  font-weight: 400;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: #4e4d59;
`;

export const ActionContainer = styled(Box).withConfig({ shouldForwardProp })<ResponsiveProps>`
  background: white;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "end")};
  height: ${({ $isPhone }) => ($isPhone ? "80px" : "97px")};
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  padding: ${({ $isPhone }) => ($isPhone ? "0" : "24px")};
`;

export const StyledButton = styled(Button).withConfig({ shouldForwardProp })<ResponsiveProps>`
  width: ${({ $isPhone }) => ($isPhone ? "80%" : "fit-content")};
  height: 49px;
  border-radius: 69px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
`;
